import format from "date-fns/format";

export const formatDate = (d: Date) => format(d, "yyyy/MM/dd");
export const formatDateTime = (d: Date) => format(d, "yyyy/MM/dd HH:mm");
export const formatSeconds = (seconds: number) => format(new Date(seconds * 1000), "mm:ss");

export function formatMoney(currency: string, amount: number) {
  switch (currency) {
    case "GBP":
      return `£${amount.toFixed(2)}`;
    case "EUR":
      return `€${amount.toFixed(2)}`;
    case "USD":
      return `$${amount.toFixed(2)}`;
    default:
      return `${currency} ${amount.toFixed(2)}`;
  }
}
